import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import CommandHistory from '../../CommandsHistory/CommandHistory';
import { CommandHistoryDropDownFilterCell } from '../../CommandsHistory/CommandHistoryDropDownFilterCell';

const useStyles = makeStyles((theme: Theme) => createStyles({}));

const NBCHistory = () => {
  const classes = useStyles();
  const dispatch: Dispatch<any> = useDispatch();

  return (
    <div>
      <CommandHistory
        title="NBC_REQUEST_HISTORY"
        commandName={'ImportItems'}
        dropDownFilterCell={CommandHistoryDropDownFilterCell}
      />
    </div>
  );
};

export default NBCHistory;
